<div class="dialog-content otp-content">
  <!--title 標題-->
  <h1
    class="dialog-title"
    [innerHTML]="'otp-dialog.enter-otp' | translate: { info: otpInfo }"
  ></h1>

  <!--btn:關閉按鈕-->
  <button mat-button class="dialog-close-btn" (click)="closeDialog()">
    <img src="assets/img/i-close.svg" alt="" />
  </button>
  <!--dialog 內容-->
  <form
    [formGroup]="otpForm"
    (ngSubmit)="onOtpSubmit()"
    class="dialog-form otp-form"
  >
    <div class="input-block">
      <!--      <label class="input-title"-->
      <!--             for="otp">{{ data.isOtpPhone? ('otp-dialog.phone-otp' | translate) : ('otp-dialog.email-otp' | translate) }}</label>-->
      <div class="input-group input-btn-right">
        <input
          id="otp"
          [placeholder]="
            data.isOtpPhone
              ? ('otp-dialog.otp-phone-placeholder' | translate)
              : ('otp-dialog.otp-email-placeholder' | translate)
          "
          formControlName="otp"
          [ngClass]="{
            'input-error':
              showOtpFormError &&
              otpForm.get('otp')?.invalid &&
              !otpForm.hasError('reachLimit', ['otp']),
          }"
          [maxLength]="otpMaxLength"
        />
        <button
          mat-button
          type="button"
          (click)="sendOtp()"
          [disabled]="!isSendOtpAvailable"
          class="btn-text-primary input-otp-btn"
        >
          {{ 'otp-dialog.send-otp' | translate }}
          @if (!isSendOtpAvailable) {
            ({{ otpRemainSeconds }}s)
          }
        </button>
        @if (showOtpFormError && otpForm.get('otp')?.invalid) {
          <mat-error
            class="input-error-msg"
            [innerHTML]="getOtpErrorMessage()"
          />
        }
      </div>
    </div>
    <button mat-button class="btn-fill-primary btn-size-l">
      {{ 'otp-dialog.validate' | translate }}
    </button>
  </form>

  <!--btn:切換驗證方式-->
  @if (data.canSwitch && (data.phoneNumber || data.email)) {
    <button mat-button (click)="toggleOtpSendTo()" class="btn-text-underline">
      {{
        data.isOtpPhone 
          ? ('otp-dialog.otp-receive-by-email' | translate)
          : ('otp-dialog.otp-receive-by-phone' | translate)
      }}
    </button>
  }
</div>

<p class="otp-help-text">
  {{ 'otp-dialog.contact-service' | translate }}
</p>

<!--btn-test 測試按鈕-->
<!-- @if (devService.isDev()) {
  <div class="btn-test">
    <mat-button-toggle-group
      name="otp-error"
      aria-label="otp-error"
      [(ngModel)]="isOtpReachedLimit"
    >
      <mat-button-toggle [value]="false">pass</mat-button-toggle>
      <mat-button-toggle [value]="true">{{
        'error.otp-error.reached-otp-limit' | translate
      }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
} -->
